export default {
	setErrors(errors){
		this.$store.state.errors = errors;
		setTimeout(() => {
	        this.$store.state.errors = [];
	    }, 5000);
	},
	setMessages(messages){
		this.$store.state.messages = messages;
		setTimeout(() => {
			this.$store.state.messages = [];
		}, 5000);
	},
	setWarnings(warnings) {
		this.$store.state.warnings = warnings;
		setTimeout(() => {
			this.$store.state.warnings = [];
		}, 5000);
	}
}